export const BUTTON_PREV_REPORTS_TEST_ID = 'button-prev-reports';
export const BUTTON_OPEN_GENERATED_TEST_ID = 'button-open-generated';
export const BUTTON_GENERATE_REPORT_TEST_ID = 'button-generate-report';
